
const createShopUrl = (basicShopUrl: string, materialNumbers: string[]): string => {
    let anzahl = 1;                         // Anzahl ist erstmal als 1 angenommen
    let isFirstMatNr = true;

    materialNumbers.map(item => {
        
            if(isFirstMatNr === true) {
                isFirstMatNr = false;
            }
            else {
                basicShopUrl = basicShopUrl + "%7c";
            }
            
            basicShopUrl = basicShopUrl + anzahl + "%24";
            basicShopUrl = basicShopUrl + item
            
            return(null);
    })

    return basicShopUrl;
}

export default function OpenKTRShop(materialNumbers: string[]) {
  
    const shopURL: string = "https://shop.ktr.com/shop(bD1kZSZjPTAxMA==)/main.do?cms_path=/cms/basket/checkout-1&zkon="; //24021405850012%7c1%24021401000042%7c1%24021405850012
  
    var link = window.document.createElement('a');
    link.href = createShopUrl(shopURL, materialNumbers);
    link.target = "_blank";
    document.body.appendChild(link);
    //open url in new window 
    link.click();
    //remove link element from body
    document.body.removeChild(link);
}
